// Iter305 · D01 (versión acotada, sin tocar fórmulas) — "contrato" de una métrica
// visible al pasar el cursor/pulsar: población, fórmula, unidad, corte y filtros.
// No redefine ni cambia ningún cálculo existente — documenta con precisión lo que
// YA calcula cada KPI, para resolver la confusión de E01 (varias definiciones de
// "hit rate" coexistiendo sin explicación).
import React from "react";
import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export function MetricInfo({ nombre, poblacion, formula, unidad, corte, filtros, testId }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          data-testid={testId || "metric-info-trigger"}
          className="inline-flex items-center justify-center text-gray-400 hover:text-[#007934] transition-colors shrink-0"
          title="Ver definición de esta métrica"
        >
          <Info size={12} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 text-xs space-y-1.5 bg-white" data-testid="metric-info-content">
        <p className="font-bold text-gray-900 text-[13px]">{nombre}</p>
        {formula && (
          <p><span className="font-semibold text-gray-600">Fórmula: </span>
            <span className="font-mono text-gray-800">{formula}</span></p>
        )}
        {poblacion && (
          <p><span className="font-semibold text-gray-600">Población: </span>{poblacion}</p>
        )}
        {unidad && (
          <p><span className="font-semibold text-gray-600">Unidad: </span>{unidad}</p>
        )}
        {corte && (
          <p><span className="font-semibold text-gray-600">Corte: </span>{corte}</p>
        )}
        {filtros && (
          <p><span className="font-semibold text-gray-600">Filtros aplicados: </span>{filtros}</p>
        )}
      </PopoverContent>
    </Popover>
  );
}
